import * as React from "react";

import "./ContentFrame.css";

interface IProps {
	iframeSrc: string;
}

const ContentFrame = (props: IProps): JSX.Element => {
	const { iframeSrc } = props;

	return <iframe className="content-iframe" src={iframeSrc} title="content-iframe" />;
};

export default ContentFrame;
